import * as React from "react"
import '../scss/paragraph.scss'
import ArrowDown from "../images/icons/ArrowDown"

const Paragraph = ({children, className, variant='normal', dotted = false, centered = false}: {
    children: any,
    className?: string,
    variant?: string,
    dotted?: boolean,
    centered?: boolean
}) => {
    return <div className={"Paragraph__Container "
    + className + " "
    + (variant? `Paragraph__Container--${variant}`: "")
    + (centered? ` Paragraph__Container--centered`: "")}>
        {dotted && <>
        <ArrowDown className="primary-fill"/>&nbsp;
        </>}
        {children}
    </div>
}

export default Paragraph